import UserInfoAndPreferences from "./UserInfoAndPreferences";

export default UserInfoAndPreferences;
